var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
import styled from '@emotion/styled';
import SVG from "../../layouts/SVG.js";
export var FlightsIcon = function FlightsIcon(props) {
  var color = props.color;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.76056 11.9894L2.26056 8.23944L5.26056 8.23944L6.76056 9.73944L9.76056 9.73944L8.26056 2.23944L11.2606 2.23944L15.0106 9.73944L19.5106 9.74999C20.1073 9.74999 20.6796 9.98705 21.1015 10.409C21.5235 10.831 21.7606 11.4033 21.7606 12C21.7606 12.5967 21.5235 13.169 21.1015 13.591C20.6796 14.0129 20.1073 14.25 19.5106 14.25L15.0106 14.2605L11.2606 21.7605L8.26056 21.7605L9.76056 14.2605L6.76056 14.2605L5.26056 15.7394L2.26056 15.7394L3.76056 11.9894Z",
    stroke: color || '#333333',
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export var FlightsIconTilt = styled(FlightsIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  transform: rotateZ(-45deg);\n"])));
export var FlightsIconSolid = styled(FlightsIcon)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  path {\n    stroke: none;\n    fill: ", ";\n  }\n"])), function (_ref) {
  var color = _ref.color;
  return color || '#333333';
});
export var FlightLanding = function FlightLanding(props) {
  var color = props.color;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 20.25H22.5",
    stroke: color || '#333333',
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 8.72458V4.79053C2.25 4.67169 2.27824 4.55455 2.33239 4.44877C2.38655 4.34298 2.46506 4.25158 2.56147 4.1821C2.65787 4.11261 2.76941 4.06703 2.88689 4.04911C3.00437 4.03118 3.12443 4.04143 3.23717 4.07902L4.5 4.49996L6 7.31246L9 8.24996V4.79053C9 4.67169 9.02824 4.55455 9.08239 4.44877C9.13655 4.34298 9.21506 4.25158 9.31147 4.1821C9.40787 4.11261 9.51941 4.06703 9.63689 4.04911C9.75437 4.03118 9.87443 4.04143 9.98717 4.07902L11.25 4.49996L14.25 9.74996L18.8029 11.0147C19.4347 11.1902 19.9916 11.5678 20.3884 12.0898C20.7852 12.6119 21 13.2495 21 13.9052V14.9315C21 15.5937 20.368 16.073 19.7304 15.8945L4.44111 11.6135C3.81071 11.437 3.25535 11.0591 2.85974 10.5375C2.46414 10.0159 2.25 9.37922 2.25 8.72458Z",
    stroke: color || '#333333',
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export var FlightTakeOff = function FlightTakeOff(props) {
  var color = props.color;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 20.25H15.75",
    stroke: color || '#333333',
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9913 15.7698L1.20951 12.988C1.12548 12.904 1.06262 12.8012 1.02611 12.6881C0.989598 12.575 0.980486 12.4549 0.999522 12.3376C1.01856 12.2202 1.0652 12.1091 1.13559 12.0134C1.20599 11.9177 1.29813 11.84 1.40443 11.7869L2.59503 11.1916L5.64443 12.1196L8.42867 10.6612L5.98248 8.21505C5.89845 8.13102 5.83559 8.02822 5.79908 7.91513C5.76257 7.80204 5.75346 7.68189 5.77249 7.56458C5.79153 7.44728 5.83817 7.33618 5.90857 7.24043C5.97896 7.14469 6.07111 7.06705 6.1774 7.0139L7.368 6.4186L13.2016 8.00959L17.3153 5.68446C17.8862 5.36181 18.547 5.23508 19.1967 5.32363C19.8464 5.41219 20.4492 5.71117 20.9128 6.17483L21.6385 6.90052C22.1067 7.36875 21.9988 8.15456 21.4217 8.4792L7.5834 16.2632C7.01283 16.5842 6.35294 16.7097 5.70438 16.6206C5.05582 16.5315 4.45421 16.2327 3.9913 15.7698Z",
    stroke: color || '#333333',
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};